import React from 'react';
import * as clevertapCapital from 'clevertap/capital';
import styles from './UploadFile.css';

class UploadFile extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      fileName: '',
    };
  }

  onChange(e) {
    if (e.target.files[0]) {
      const {
        input: { onChange, name },
        allowPDF,
      } = this.props;
      let key = name;
      if (name === 'kk') {
        key = 'Kartu Keluarga';
      } else if (name === 'ktp') {
        key = 'KTP';
      } else if (name === 'npwp') {
        key = 'NPWP';
      } else if (name === 'ktp_spouse') {
        key = 'KTP of Spouse';
      } else if (name.indexOf('bank_statement') >= 0) {
        key = 'Bank Statement';
      } else if (name === 'verification_photo') {
        key = 'Verification Photo';
      }
      let isPDF = false;
      let fileTypes = ['jpg', 'jpeg', 'png'];
      const extension = e.target.files[0].name
        .split('.')
        .pop()
        .toLowerCase();
      if (allowPDF) {
        fileTypes = ['jpg', 'jpeg', 'png', 'pdf'];
        isPDF = extension === 'pdf';
      }
      const fileName = e.target.files[0].name;
      const fileSize = e.target.files[0].size;
      const isSuccess = fileTypes.indexOf(extension) > -1;
      const isTooBig = fileSize > 2107152;
      if (isSuccess && !isTooBig) {
        const base64File = new window.FileReader();
        base64File.readAsDataURL(e.target.files[0]);
        base64File.onload = function() {
          let header = '';
          const results = base64File.result.split(',');
          const arrayBuffer = _base64ToArrayBuffer(results[1]);
          const arr = new Uint8Array(arrayBuffer).subarray(0, 4);
          for (let i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
          }
          if (
            !isPDF &&
            (header !== 'ffd8ffe0' &&
              header !== 'ffd8ffdb' &&
              header !== 'ffd8ffe1' &&
              header !== '89504e47' &&
              header !== '47494638')
          ) {
            onChange({ code: 'tampered file', name: fileName });
          } else {
            clevertapCapital.uploadImageForm(fileName, key);
            onChange({ code: results[1], name: fileName });
          }
        };
        base64File.onerror = function() {
          onChange('');
        };
      } else if (isTooBig) {
        onChange({ code: 'file Too Big', name: fileName });
      } else {
        onChange({ code: 'forbiden type', name: fileName });
      }
    }
  }

  render() {
    const {
      className,
      meta: { touched, error },
      input: { value, name },
      indexFile = -1,
      fields,
      placeHolderFile,
    } = this.props;

    return (
      <div>
        <input
          className={className}
          disabled
          value={
            value
              ? value.name
              : !placeHolderFile
              ? 'Upload Your File'
              : placeHolderFile
          }
        />
        <input
          type="file"
          className={className}
          onChange={this.onChange}
          id={name}
          style={{ display: 'none' }}
        />
        <label className={styles['label-upload']} htmlFor={name}>
          {' '}
          Browse{' '}
        </label>
        {indexFile > 0 && (
          <a
            className={`btn ${styles['remove-file']}`}
            onClick={() => fields.remove(indexFile)}
          >
            <span className="glyphicon glyphicon-remove" />
          </a>
        )}
        <small className={styles.error}>{touched ? error : ''}</small>
      </div>
    );
  }
}

function _base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export default UploadFile;
